import { create } from "zustand";

export type CampaignFilterStore = {
  searchTerm: string;
  status: string;
  pageOptions: {
    search: string;
    status: string;
  };
  actions: {
    setSearchTerm: (searchTerm) => void;
    setStatus: (status: string) => void;
    resetFilters: () => void;
  };
};

export const useCampaignFilterStore = create<CampaignFilterStore>((set) => ({
  searchTerm: "",
  status: "",
  pageOptions: {
    search: "",
    status: "",
  },
  actions: {
    setSearchTerm: (searchTerm: string) =>
      set((state) => ({
        searchTerm,
        pageOptions: { ...state.pageOptions, search: searchTerm },
      })),
    setStatus: (status: string) =>
      set((state) => ({
        status,
        pageOptions: { ...state.pageOptions, status },
      })),
    resetFilters: () =>
      set(() => ({
        searchTerm: "",
        status: "",
        pageOptions: {
          search: "",
          status: "",
        },
      })),
  },
}));

export const useCampaignFilterStoreActions = () =>
  useCampaignFilterStore((state) => state.actions);
